import { useSelector } from 'react-redux';
import classnames from 'classnames/bind';

import * as $auth from 'modules/auth';

import styles from './Header.module.css';

import { PublisherSelector } from 'view/components/admin/PublisherSelector';
import { UserProfileMenu } from '../UserProfileMenu/UserProfileMenu';

const cls = classnames.bind(styles);

export const Header = ({ className }) => {
  const isUserAdmin = useSelector($auth.getIsCurrentUserAdmin);

  return (
    <div className={cls('container', className)}>
      {isUserAdmin && <PublisherSelector />}

      <UserProfileMenu className="ml-auto" />
    </div>
  );
};
